import { defineStore } from 'pinia'
import { router } from '../helpers'
import {
  fetchReadinessAssesment,
  patchReadinessAssessment,
  createReadinessAssessment,
  createReadinessReportCard,
  fetchReadinessReportCards,
  fetchReadinessReportCard
} from '../helpers/api'
import { notify } from 'notiwind';

export const useAssessmentsStore = defineStore('assessments', {
  state: () => ({
    readinessAssessments: {},
    readinessReportCards: {},
  }),
  actions: {
    async fetchAssessmentById(id) {
      const response = await fetchReadinessAssesment(id).catch(error => {
        notify({
          group: "foo",
          type: "error",
          title: "Ruh roh!",
          text: `Something went wrong! ${error}`
        }, 4000)
      })

      this.readinessAssessments[id] = response.readiness_assessment
      const reportCardId = response.readiness_assessment.readiness_report_card_id

      const reportCardAssessments = this.readinessReportCards[reportCardId] && this.readinessReportCards[reportCardId].readiness_assessment_ids ? this.readinessReportCards[reportCardId].readiness_assessment_ids : []

      this.readinessReportCards[reportCardId] = {
        ...response.readiness_report_card.attributes,
        readiness_assessment_ids: [...reportCardAssessments, ...[id]],
        title: response.readiness_report_card.attributes.readiness_guide.title
      }
    },
    async createReadinessReportCard(childId) {
      await createReadinessReportCard(childId).then(response => {
        this.readinessReportCards[response.readiness_report_card.id] = response.readiness_report_card
        router.push(`/readiness/report-card/${response.readiness_report_card.id}`)
      })
    },
    async createReadinessAssessment(childId, reportCardId, readinessAreaId) {
      await createReadinessAssessment(childId, reportCardId, readinessAreaId).then(response => {
        this.readinessAssessments[response.readiness_assessment.id] = response.readiness_assessment
        router.push(`/readiness/assessments/${response.readiness_assessment.id}`)
      })
    },
    async fetchReadinessReportCards() {
      fetchReadinessReportCards().then(response => {
        this.readinessReportCards = response.reduce((acc, reportCard) => {
          acc[reportCard.id] = { id: reportCard.id, ...this.readinessReportCards[reportCard.id], ...reportCard.attributes }
          return acc
        }, {})
      }).catch(error => {
        notify({
          group: "foo",
          type: "error",
          title: "Ruh roh!",
          text: `Something went wrong! ${error}`
        }, 4000)
      })
    },
    async patchReadinessAssessment({ id, assessment_milestones, notes, completed, note_id }) {
      const updateParams = { readiness_assessment: { id, assessment_milestones, notes, note_id } }
      if (completed === true || completed === false) {
        updateParams.readiness_assessment.completed = completed
      }
      await patchReadinessAssessment(id, updateParams).then(response => {
        this.readinessAssessments[id] = response.readiness_assessment
        const reportCardId = response.readiness_report_card.id
        this.readinessReportCards[reportCardId].readiness_map = response.readiness_report_card.attributes.readiness_map
      })
      if (completed === true) {
        router.push(`/readiness/report-card/${this.readinessAssessments[id].readiness_report_card_id}`)
        notify({
          group: "foo",
          type: "success",
          title: "Woohoo!",
          text: "A few small steps today open many doors tomorrow"
        }, 4000)
      }
    },
    async fetchReadinessReportCarById(id) {
      await fetchReadinessReportCard(id).then(response => {
        const mappedAssessments = response.readiness_assessments.map(assessment => assessment.attributes)
        this.readinessAssessments = Object.assign(this.readinessAssessments, mappedAssessments.reduce((acc, assessment) => {
          acc[assessment.id] = assessment
          return acc
        }, {}))
        this.readinessReportCards[id] = {
          ...response.readiness_report_card.attributes,
          readiness_assessment_ids: mappedAssessments.map(assessment => assessment.id),
          title: response.readiness_report_card.attributes.readiness_guide.title
        }
      })
    },
  },
  getters: {
    getAssessmentById: (state) => (id) => {
      return state.readinessAssessments[id]
    },
    getAssessments: (state) => {
      return Object.values(state.readinessAssessments)
    },
    getReadinessReportCardById: (state) => (id) => {
      return state.readinessReportCards[id]
    },
    getReadinessReportCards: (state) => {
      return Object.values(state.readinessReportCards)
    },
    getReportCardAssessments: (state) => (id) => {
      if (!state.readinessReportCards[id].readiness_assessment_ids) {
        return []
      }
      return state.readinessReportCards[id].readiness_assessment_ids.map(id => state.readinessAssessments[id])
    },
    getReportCardsByChildId: (state) => (id) => {
      return Object.values(state.readinessReportCards).filter(reportCard => reportCard.child_id === id)
    }
  }
});